import GeneralWrapper, { FirstContainer, FirstWrapper } from "./Elements";
import { IContent, IHeader, ITheme } from "../../types";
import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import TeamsContainer from "./TeamsContainer";
import EnterenceContainer from "./EnterenceContainer";
import SmoothScroll from "../../components/SmoothScroll";
import RoadMap from "./RoadMap";
import { Faq } from "./Faq";
import Header from "../../components/Header";
import SnowEff from "../../components/SnowEff";
import { Background1 } from "./Background1";
import Footer from "../../components/Footer/Footer";
import Video from "./VideoContainer";
import Logo from "./Logo";

const Landing: React.FC = () => {
  const data: IContent = require("../../data/json/text.json");
  const themeData: ITheme = require("../../data/json/theme.json");

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    gsap.utils.toArray(".box").forEach((box: any) => {
      ScrollTrigger.create({
        trigger: box,
        pin: true,
        start: "top top",
        end: "+=300",
      });
    });
  }, []);

  return (
    // <SmoothScroll>
      <GeneralWrapper>
        <FirstWrapper>
          <FirstContainer>
            <Header />
          </FirstContainer>

          <Logo/>

          <div className={"EnterenceContainer"}>
            <EnterenceContainer />
          </div>

          <Background1 />
          <div className={"AboutMe"}>
            <RoadMap data={data["landing"]["containers"][0]} />
          </div>

          <div>
            <Faq data={data["landing"]["containers"][2]} />
          </div>


          <Video  />

          <div className={"TeamsContainer"}>
            <TeamsContainer
              data={data["landing"]["containers"][1]}
              theme={themeData}
            />
          </div>
       
          <SnowEff />
        </FirstWrapper>
      </GeneralWrapper>
    // {/* </SmoothScroll> */}
  );
};

export default Landing;
